/* ===== Mueblika · Accesorios solo con canapé, colchón, base o pack =====
   Va junto al snippet mbk-accesorios (que lo carga). Mantiene al día
   las marcas de la página según lo que hay en el carrito:
     html.mbk-sin-principal → no hay ningún producto principal.
     html.mbk-acc-bloqueado → hay accesorios pero ningún principal.
   Funciona con el carrito lateral y la página del carrito de Horizon
   sin tocar sus archivos: vigila los cambios del carrito y los
   botones de pago estén donde estén.
   ====================================================================== */
/* Burbuja del carrito: pinta el número y avisa a Horizon con su evento
   "cart:update" para que su icono del carrito también se entere. Se
   llama DESPUÉS de redibujar la cabecera, porque al redibujarla el
   icono de Horizon se reinicia y podía volver a esconder la burbuja. */
window.mbkPintarBurbuja = window.mbkPintarBurbuja || function (cart, emitir) {
  var n = (cart && cart.item_count) || 0;
  [
    '.cart-bubble__text-count',
    '[ref="cartBubbleCount"]',
    '[data-cart-count]',
    '.cart-count',
    '.cart-count-bubble',
    '.cart-icon-bubble',
    '[data-cart-item-count]'
  ].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
      if (n > 0) el.removeAttribute('hidden');
    });
  });
  // El círculo que envuelve el número (en Horizon lleva "visually-hidden"
  // cuando el carrito está vacío)
  document.querySelectorAll('.cart-bubble, [ref="cartBubble"]').forEach(function (el) {
    el.classList.toggle('visually-hidden', n === 0);
    if (n > 0) {
      el.classList.remove('hidden');
      el.removeAttribute('hidden');
    }
  });
  if (emitir) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'mbk', data: { itemCount: n, source: 'mbk' } }
      }));
    } catch (e) {}
  }
};

(function () {
  'use strict';

  var cfg = window.mbkAccesorios || {
    principales: ['Canapés y Bases', 'Colchones', 'Packs y Promociones'],
    accesorio: 'Accesorios'
  };
  var root = document.documentElement;
  var rutaBase = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var AVISO_CARRITO =
    'Los accesorios solo se pueden comprar junto con un canapé, colchón, base tapizada o pack. ' +
    'Añade uno al carrito o quita los accesorios para continuar.';
  var AVISO_FICHA =
    'Este accesorio solo se puede comprar junto con un canapé, colchón, base tapizada o pack. ' +
    'Añade antes uno de ellos al carrito.';
  var SEL_PAGO = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';

  var estado = {
    principal: !root.classList.contains('mbk-sin-principal'),
    bloqueado: root.classList.contains('mbk-acc-bloqueado')
  };

  /* ---------- Variantes que son accesorios ---------- */
  function idsAccesorio() {
    var ids = {};
    (cfg.variantes || []).forEach(function (id) { ids[String(id)] = true; });
    document.querySelectorAll('[data-mbk-accesorio][data-variant-id]').forEach(function (el) {
      ids[String(el.getAttribute('data-variant-id'))] = true;
    });
    return ids;
  }

  /* Formularios de "añadir al carrito" de cualquier tipo (también el
     nativo de Horizon) que añaden un accesorio: se marcan igual que
     los nuestros y se les pone el aviso. */
  function marcarFormularios(ids) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('[name="id"]');
      if (!input || !ids[String(input.value)]) return;
      form.querySelectorAll('button[type="submit"], button[name="add"], button:not([type])').forEach(function (b) {
        b.setAttribute('data-mbk-accesorio', '');
      });
      if (!form.querySelector('.mbk-acc-aviso')) {
        var aviso = document.createElement('p');
        aviso.className = 'mbk-acc-aviso';
        aviso.textContent = AVISO_FICHA;
        form.appendChild(aviso);
      }
    });
  }

  /* ---------- Pintar el estado en la página ---------- */
  function aplicar() {
    marcarFormularios(idsAccesorio());
    root.classList.toggle('mbk-sin-principal', !estado.principal);
    root.classList.toggle('mbk-acc-bloqueado', estado.bloqueado);

    document.querySelectorAll('[data-mbk-accesorio]').forEach(function (btn) {
      if (estado.principal) btn.removeAttribute('aria-disabled');
      else btn.setAttribute('aria-disabled', 'true');
    });

    document.querySelectorAll(SEL_PAGO).forEach(function (el) {
      if (estado.bloqueado) el.setAttribute('aria-disabled', 'true');
      else el.removeAttribute('aria-disabled');

      // Aviso encima del botón de pagar (se crea una vez; el CSS lo
      // enseña u oculta según el estado).
      var previo = el.previousElementSibling;
      if (!previo || !previo.classList.contains('mbk-acc-aviso-carrito')) {
        var aviso = document.createElement('p');
        aviso.className = 'mbk-acc-aviso-carrito';
        aviso.setAttribute('role', 'status');
        aviso.textContent = AVISO_CARRITO;
        el.parentNode.insertBefore(aviso, el);
      }
    });
  }

  /* ---------- Leer el carrito ---------- */
  var fetchOriginal = window.fetch.bind(window);

  function comprobar() {
    return fetchOriginal(rutaBase + 'cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var tipos = (cart.items || []).map(function (i) { return i.product_type; });
        var principal = tipos.some(function (t) { return cfg.principales.indexOf(t) !== -1; });
        var accesorio = tipos.indexOf(cfg.accesorio) !== -1;
        estado = { principal: principal, bloqueado: accesorio && !principal };
        aplicar();
        corregirBurbuja(cart);
      })
      .catch(function () { /* si falla, se queda el estado que vino del servidor */ });
  }

  /* Burbuja del carrito: en algunas páginas (p. ej. la colección de
     Accesorios) se quedaba borrada al entrar aunque el carrito tuviera
     productos. Cada vez que leemos el carrito, si la burbuja no enseña
     el número real, se vuelve a pintar y se avisa a Horizon. */
  function corregirBurbuja(cart) {
    var n = cart.item_count || 0;
    var num = document.querySelector('[ref="cartBubbleCount"], .cart-bubble__text-count');
    var circulo = document.querySelector('[ref="cartBubble"], .cart-bubble');
    if (!num && !circulo) return;
    var enPantalla = num ? (parseInt(num.textContent, 10) || 0) : 0;
    var oculta = (circulo && (circulo.classList.contains('visually-hidden') || circulo.hidden)) ||
                 (num && (num.classList.contains('hidden') || num.hidden));
    var bien = n === 0 ? true : (enPantalla === n && !oculta);
    if (!bien && window.mbkPintarBurbuja) window.mbkPintarBurbuja(cart, true);
  }

  var temporizador = null;
  function programar() {
    clearTimeout(temporizador);
    temporizador = setTimeout(comprobar, 150);
  }

  /* Cualquier cambio en el carrito hecho con fetch (añadir, quitar,
     cambiar cantidad, vaciar), venga del tema o de nuestros scripts,
     vuelve a comprobar el estado. */
  function idsDelCuerpo(body) {
    var ids = [];
    try {
      if (!body) return ids;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        body.forEach(function (v, k) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); });
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        body.forEach(function (v, k) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); });
      } else if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.id) ids.push(String(j.id));
          (j.items || []).forEach(function (i) { if (i.id) ids.push(String(i.id)); });
        } else {
          new URLSearchParams(body).forEach(function (v, k) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); });
        }
      }
    } catch (e) { /* cuerpo desconocido: no se bloquea */ }
    return ids;
  }

  function respuestaBloqueo() {
    // Mismo formato que un error de Shopify: el tema enseña el texto
    // de "description" como mensaje de error junto al botón.
    return Promise.resolve(new Response(
      JSON.stringify({ status: 422, message: 'Accesorio', description: AVISO_FICHA }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    ));
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!estado.principal && /\/cart\/add/.test(url)) {
      var ids = idsDelCuerpo(init && init.body);
      var acc = idsAccesorio();
      // Solo se bloquea si TODO lo que se añade son accesorios (si va
      // junto con un canapé, colchón, base o pack, se deja pasar).
      if (ids.length && ids.every(function (id) { return acc[id]; })) {
        return respuestaBloqueo();
      }
    }
    var promesa = fetchOriginal(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promesa.then(programar, function () {});
    }
    return promesa;
  };

  /* ---------- Bloqueos (también con teclado) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!estado.principal && t.closest('[data-mbk-accesorio]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (estado.bloqueado && t.closest(SEL_PAGO)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var inputId = form.querySelector && form.querySelector('[name="id"]');
    var esAcc = form.querySelector && (form.querySelector('[data-mbk-accesorio]') ||
      (inputId && /\/cart\/add/.test(form.getAttribute('action') || '') && idsAccesorio()[String(inputId.value)]));
    if (!estado.principal && esAcc) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var boton = e.submitter;
    var vaAPagar = (boton && boton.name === 'checkout') || /\/checkout/.test(form.getAttribute('action') || '');
    if (estado.bloqueado && vaAPagar) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  /* ---------- El carrito lateral se redibuja: volver a aplicar ---------- */
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      aplicar();
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Volver atrás con el navegador puede enseñar una página guardada
  // con un carrito antiguo.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) comprobar();
  });

  aplicar();
  comprobar();
  // Segunda comprobación cuando ya ha cargado todo el tema, por si
  // algún componente de Horizon esconde la burbuja después.
  window.addEventListener('load', function () { setTimeout(comprobar, 600); });
})();